<template>
  <SidePanel
    :isVisible="true"
    @save="onCancel"
    :header="$t('sendMessage.header')"
    cancel="Abbrechen"
    :leftCommand="false"
    :rightCommand="true"
  >
    <div class="sidepanel-body pt-1">
      <div class="contact-list">
        <div class="admin-header mt-2">
          <p> {{ $t('sendMessage.recipient') }} </p>
        </div>
        <div class="contacts-box list" v-if="userArray.length > 0">
            <div class="contact-item" v-for="adminDetail in userArray" :key="adminDetail.user_name">
                <div class="contact-icon">
                    {{ getInitials(adminDetail.user_name) }}
                </div>
                <div
                  class="contact-details pointer"
                  @click="toggleContactSelect(adminDetail)"
                  >
                  <div class="contact-user">
                      <div class="contact-name">
                        {{ adminDetail.user_name }}
                      </div>
                      <div class="contact-email">
                        {{ adminDetail.email }}
                      </div>
                  </div>
                  <div class="contact-select">
                      <!-- <div class="checked-circle">
                        <font-awesome-icon class="" :icon="['fal', 'check']" />
                      </div> -->
                      <div class="checked-circle" v-if="adminDetail.isSelected">
                        <font-awesome-icon class="" :icon="['fal', 'check']" />
                      </div>
                      <div v-else class="empty-circle"></div>
                  </div>
                </div>
            </div>
        </div>
        <div class="border-envelope">
            <!-- <div class="envelope-header mt-2 mb-2">
                {{ $t('sendMessage.previewHeader') }}
            </div> -->
            <div class="invite-message-box">
                <!-- <div class="form-group">
                    <label class="font-weight-600 mb-0" for="subject">{{ $t('sendMessage.subject') }}</label>
                    <textarea
                        id="subject"
                        class="form-control"
                        cols="50"
                        rows="1"
                        v-model="subject"
                    ></textarea>
                </div> -->
                <label class="font-weight-600 mb-0" for="userMessage">{{ $t('sendMessage.message') }}</label>
                <div class="form-group user-message-group">
                    <!-- <div class="envelope-message-freetext ml-1 mr-1">
                        {{ message }}
                    </div> -->
                    <div class="user-message-textarea">
                        <textarea
                            id="userMessage"
                            class="form-control text-size-14"
                            cols="50"
                            rows="2"
                            :placeholder="$t('sendMessage.userMessage')"
                            v-model="userMessage"
                        ></textarea>
                    </div>
                    <!-- <div class="form-group personalized-link mt-2 ml-1 mr-1" v-html="pollUrl">
                    </div>
                    <div class="form-group kulibri-team ml-1">
                        {{ $t('invite.kulibriTeam') }}
                    </div> -->
                </div>
            </div>
        </div>
        <div class="mt-3 mb-4">
          <Btn
            @click.native="inviteEmails"
            :label="
              $t('sendMessage.sendMessage')
            "
            :loading="loading"
            :fullWidth="true"
            :disabled="!enableDisableSendInvitationButton"
          />
          <p class="invite-ack mt-1 mb-0" v-if="sentMailAcknowledgement">
            {{ sentMailAcknowledgement }}
          </p>
        </div>
      </div>
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import shared from '@/shared.js';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import { renderMixin } from '../mixins/RenderMixins';
import { HTTP } from '@/shared/http';

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SendMessageToAdmin',

  props: [],
  mixins: [modalParticipantMixins, renderMixin],
  components: {
    SidePanel,
  },

  data() {
    return {
      subject: '',
      message: '',
      userMessage: '',
      // TODO: check if array for selected is needed (different sort order??)
      loading: false,
      sentMailAcknowledgement: '',
      userLocale: this.$i18n.locale,
      senderEmail: '',
      userArray: [],
      selectedUserCounter: 0
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      user: (state) => state.Login.user
    }),
    
    ...mapGetters([
      'publicKey',
      'userName',
      'isAuthenticated',
      'userId'
    ]),

    mandatoryEmail: {
      get() {
        if (this.poll.options.mandatoryEmail == null) return false;
        return this.poll.options.mandatoryEmail;
      },
      set(value) {
        this.$store.commit('updateMandatoryEmail', value);
        this.$store.commit('updateOptions', this.poll.options);
      },
    },

    pollUrl() {
      return this.$t('sendMessage.projectLink', {
          projectLink: this.poll.title
      });
    },
    enableDisableSendInvitationButton() {
      return this.userMessage && this.selectedUserCounter > 0;
    },
  },

  methods: {
    onCancel() {
        this.$emit('cancel');
    },

    inviteEmails() {
      let adminEmailsOnly = [];
      for(let i = 0; i < this.userArray.length; i++) {
        if(this.userArray[i].isSelected == true) 
          adminEmailsOnly.push(this.userArray[i].email);
      }
      if(adminEmailsOnly.length == 0) {
        return;
      }
      let invitations = {
        id: this.poll.id,
        subject: this.subject,
        message: this.userMessage,
        message1: this.message,
        emails: '',
        contacts: JSON.stringify(adminEmailsOnly),
        autAddParticipants: false,
        userLocale: this.user ? this.user.locale : this.userLocale
      };
      console.log('invitations', invitations);
      this.loading = true;
      this.resetAck();

      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/message-to-admin';

      return HTTP.post(url, invitations)
        .then((response) => {
          this.loading = false;
          console.log('response:', response.data);
          this.sentMailAcknowledgement = this.$t(
            'sendMessage.messageSent'
          );
          window.setTimeout(() => {
            this.resetAck();
          }, 2000);
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
        });
    },

    resetAck() {
      this.sentMailAcknowledgement = '';
    },
    getAdminAndSubAdmins() {
      this.userArray = [];
      if(this.poll && this.poll.user) {
        this.userArray.push({user_name: this.poll.user_name, email: this.poll.user.email, isSelected: true});
      }
      this.poll.participants.forEach(participant => {
        if(participant.is_sub_admin == 1) {
          let participantData = {user_name: "", email: "", isSelected: true};
          if(participant.user) {
            // if participant has not given name then we can display from the registered user list.
            participantData.user_name = participant.name || participant.user.name;
            participantData.email = participant.user.email;
          } else {
            participantData.user_name = participant.name;
          }
          this.userArray.push(participantData);
        }
      });
      this.selectedUserCounter = this.userArray.length;
      return this.userArray;
    },
    toggleContactSelect(user) {
      user.isSelected = !user.isSelected;
      user.isSelected == true ? this.selectedUserCounter++ : this.selectedUserCounter--;
    }
  },

  created() {

    let creatorName = '';
    for(let i = 0; i < this.poll.participants.length; i++) {
      if(this.userId == this.poll.participants[i]['user_id']) {
        creatorName = this.poll.participants[i]['name'];

        if (this.poll.participants[i]['invitation'] != null) {
          this.senderEmail = this.poll.participants[i]['invitation']['email'];
        }
        else if (this.poll.participants[i]['user'] != null) {
          this.senderEmail = this.poll.participants[i]['user']['email'];
        }        
        
        if(this.poll.participants.user) {
          this.userLocale = this.poll.participants[i]['user']['locale'];
        }
        break;
      }
    }

    this.subject = this.$t('sendMessage.subjectText', {
      userName: creatorName,
      pollTitle: this.poll.title
    });
    this.message = this.$t('sendMessage.messageText', {
      userName: creatorName,
      pollTitle: this.poll.title,
      email: this.senderEmail
    });

    this.getInitials = shared.getInitials;
    this.getAdminAndSubAdmins();
    console.log('created completed');
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';

.border-envelope {
  padding: 5px;
  background-image: url(/images/envelope-border.png);
  background-position: 0 100%;
  background-repeat: repeat-x, repeat-y;
  background-size: 40px 3px;
}

.invite-public-link-box {
  display: flex;
  justify-content: space-between;
}

.invite-public-link {
  color: $light-grey;
}

.contacts-box {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  border: 1px solid $light-grey;

  overflow: auto;
  width: 100%;
  overflow-x: hidden;
  &.list {
    max-height: 575px;
  }
  &.selected {
    max-height: 125px;
  }
}

.contact-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.contact-icon {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding-left: 0px;
  padding-top: 8px;
  display: block;
  background: $user-bubble;
  border: 0px solid;
  color: $dark-grey;
  text-align: center;
  font: 14px Arial, sans-serif;
  margin-right: 1rem;
  text-transform: uppercase;
}

.contact-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid $light-grey;
  width: 100%;
}

.contact-user {
  display: flex;
  flex-direction: column;
  width: 80%;
}

.contact-name {
  font-weight: bold;
  color: $dark-grey;
}

.contact-email {
  font-weight: normal;
  color: $light-grey;
  font-size: 0.8rem;
}

.contact-select {
  align-self: center;
}

.checked-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: $dark-grey;
  border: 1px solid $dark-grey;
  color: white;
  text-align: center;
}

.empty-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: white;
  border: 1px solid $dark-grey;
  color: white;
  padding: 6px;
}

.invitation-link {
  color: $grid-border;

  p {
    font-weight: $semi-bold-weight;
    margin-bottom: 0px;
  }
}

.invite-ack {
  color: $white;
  text-align: center;
  background-color: $primary-dark;
  padding: 10px;
}

.send-invitation-btn {
  width: 100%;
}

.display-left {
  float: left;
}

.display-right {
  cursor: pointer;
  color: $primary;
  float: right;
}

.btn-secondary:disabled {
  cursor: not-allowed;
}

.and-or {
  font-size: $big;
  text-align: center;
}

.text-end {
  text-align: end !important;
}
.btn-primary:disabled {
  cursor: not-allowed;
}

.display-flex {
  display: flex;
  justify-content: space-between;
}

.admin-header {
  font-weight: $bold-weight;
  font-size: $standard;

  p {
    margin-bottom: 0px;
  }
}

.border-envelope {
    .envelope-header {
        font-size: $standard;
        color: $dark-grey;
        font-weight: $semi-bold-weight;
    }
    .envelope-message-freetext {
        word-break: break-word;
        white-space: pre-line;
    }
    .personalized-link {
        word-break: break-word;
        white-space: pre-line;
    }
}

// ::v-deep .personalized-link {
//   span.custom-link {
//     color: $primary;
//     cursor: pointer;
//   }
// }
</style>
